import { SystemConstant } from "const";
import { ExecuteEvent } from "pubsub/PubSub.const";
import store, { CallingActions, SystemActions } from "redux-store";
import { getInteractor } from "services/local.service";
import { deleteMessageAfterDeleteCallingHistory } from "services/message.service";

export const deleteCallHistory = async (prefixKey, { room_ids, call_history_ids }) => {
  try {
    if (room_ids.includes("select_all")) {
      await getInteractor(prefixKey).LocalCallHistoryService.update(
        {
          state: SystemConstant.STATE.inactive,
          modified: Date.now(),
        },
        {
          state: SystemConstant.STATE.active,
        },
      );
    } else {
      const updateCallList = room_ids.map(item => ({
        updateValues: {
          state: SystemConstant.STATE.inactive,
          modified: Date.now(),
        },
        condition: {
          room_id: item,
        },
      }));
      await getInteractor(prefixKey).LocalCallHistoryService.updateListByCondition(updateCallList);
    }

    //  Delete calling messages after deleting calling history
    const isDeleteCallingMessage = await deleteMessageAfterDeleteCallingHistory({
      prefixKey: prefixKey,
      call_history_ids: call_history_ids,
      room_ids: room_ids,
    });

    store.dispatch(
      CallingActions.callingSet({
        deleteCallRoomIds: room_ids,
      }),
    );

    return isDeleteCallingMessage ? ExecuteEvent.SUCCESSES : ExecuteEvent.RETRY;
  } catch (error) {
    console.log("event delete call history fail: ", error); // eslint-disable-line no-console
  }

  return ExecuteEvent.FAIL;
};

export const seenCallHistory = async (prefixKey, callHistoryIds) => {
  try {
    const updateValue = callHistoryIds.map(item => ({
      updateValues: {
        action_status: SystemConstant.CALL_HISTORY_ACTION_STATUS.seen,
        modified: Date.now(),
      },
      condition: { id: item },
    }));
    await getInteractor(prefixKey).LocalCallHistoryService.updateListByCondition(updateValue);

    // Dispatch to update view
    store.dispatch(
      SystemActions.systemSet({
        seenCallHistoryTimestamp: Date.now(),
      }),
    );

    return ExecuteEvent.SUCCESSES;
  } catch (error) {
    console.log("seen call history event fail: ", error); // eslint-disable-line no-console
  }

  return ExecuteEvent.FAIL;
};
